import React, { useState } from "react"
import styled from "styled-components"
import fonts from "../../../styles/fonts"
import colors from "../../../styles/colors"
import { Trans, withTranslation } from "gatsby-plugin-react-i18next"
import Field from "./Field"
import { Intro, SubmitButton, Title } from "./Styles"
import { createUser } from "../../../services/user/user"
import { CONFIRM } from "../../../context/form/formTypes"

const StyledTitle = styled(Title)`
  margin-bottom: 17px;
  text-align: center;
  margin-top:-2px;
`
const StyledIntro = styled(Intro)`
  margin-bottom: 40px;
  text-align: center;
`

const ErrorMessage = styled(Intro)`
  color: #db3232;
  margin-bottom: 40px;
  margin-top: -30px;
`

const Fields = styled.div`
  position: relative;
`

const FieldContainer = styled.div`
  margin-bottom: 40px;
  padding: 0;
  padding-right: ${props => props.long ? "34px" : "0"};
  @media (min-width: 721px) {
    flex: ${(props) => (!props.half ? "100%" : props.long ? "59.2%" : "40.8%")};
    padding-right: ${props => props.long ? "34px" : "0"};
  }
`
const RowFieldContainer = styled(FieldContainer)`
  padding-right: ${props => props.long ? "9.5px" : "0"};
  padding-left: ${props => props.long ? "0" : "9.5px"};
  @media (min-width: 721px) {
    flex: ${(props) => (!props.half ? "100%" : props.long ? "56.8%" : "43.2%")};
    padding-right: ${props => props.long ? "21px" : "0"};
    padding-left: ${props => props.long ? "0" : "21px"};
  }
`

const StyledSubmitButton = styled(SubmitButton)`
  margin-bottom: 8px;
`

const Terms = styled.div`
  ${fonts.helveticaNeue};
  color: ${colors.grey};
  font-size: 8px;
  line-height: 1.25;
  text-align: center;
  a {
    color: #666666;
  }
`

const DoubledFields = styled.div`
  display: flex;
`

const Register = ({ t, setContent, setEmail, setFullName }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    surName: "",
    email: "",
    password: "",
    password2: "",
  })
  const [errors, setErrors] = useState({
    firstName: "",
    surName: "",
    email: "",
    password: "",
    password2: "",
  })

  const [submitError, setSumbitError] = useState(null)


  const handleChange = (name, value) => {
    let updatedFormData = formData

    updatedFormData[name] = value
    setFormData(updatedFormData)
  }

  const validateForm = () => {

    let hasError = false
    const formFields = Object.keys(formData)
    const updatedErrors = {
      firstName: "",
      surName: "",
      email: "",
      password: "",
      password2: "",
    }

    formFields.forEach((formField) => {
      if (formData[formField].length === 0) {
        updatedErrors[formField] = t("account.form_empty_field_error")
        hasError = true;
      }
      if(formField === "password" ) {
        const regex = /^(?=\S*[A-Z])(?=\S*[^\w\s])\S{8,}$/;
        const isCorrect = regex.test(formData[formField])

        if(!isCorrect && formData[formField].length > 0 ) {
          updatedErrors[formField] = t("account.form_password_format_error")
          hasError = true;
        }
      }
    })

    if (formData["password"] !== formData["password2"]) {
      if(updatedErrors["password2"] === "") {
        updatedErrors["password2"] = t("account.form_different_passwords_error")
        hasError = true;
      }
    }

    setErrors(updatedErrors)
    return hasError
  }

  const submitForm = async (e) => {
    e.preventDefault()
    setSumbitError(null)

    const hasError = validateForm();

    if (hasError) {
      return
    }


    try {
      const fullName = `${formData.firstName} ${formData.surName}`
      const data = {
        fullName: fullName,
        email: formData.email,
        password: formData.password,
        dob: null,
        phone: null
      }
      const result = await createUser(data)
      if(result.data && result.data.status && result.data.status === "Email already exists in database") {
        setSumbitError(t("account.form_email_exist_error"))
      } else {
        setEmail(formData.email)
        setFullName(fullName)
        setContent(CONFIRM)
      }
    } catch (error) {
      console.error(error)
      setSumbitError(t("account.form_submit_error"))
    }
  }

  return (
    <form onSubmit={submitForm}>
      <StyledTitle>{t("account.register_title")}</StyledTitle>
      <StyledIntro>{t("account.register_intro")}</StyledIntro>
      {submitError && (
        <ErrorMessage>{t("account.form_submit_error")}</ErrorMessage>
      )}
      <Fields>
        <DoubledFields>
          <RowFieldContainer half long first>
            <Field
              data={formData}
              name="firstName"
              placeholder={t("account.form_first_name_placeholder")}
              label={t("account.form_first_name_placeholder")}
              handleChange={handleChange}
              error={errors.firstName}
              isPopup
            />
          </RowFieldContainer>
          <RowFieldContainer half short first>
            <Field
              data={formData}
              name="surName"
              placeholder={t("account.form_surname_placeholder")}
              label={t("account.form_surname_placeholder")}
              handleChange={handleChange}
              error={errors.surName}
              isPopup
            />
          </RowFieldContainer>
        </DoubledFields>

        <FieldContainer >
          <Field
            data={formData}
            name="email"
            placeholder={t("account.form_email_placeholder")}
            label={t("account.form_email_placeholder")}
            handleChange={handleChange}
            type="email"
            error={errors.email}
            isPopup
          />
        </FieldContainer>
        <FieldContainer>
          <Field
            data={formData}
            name="password"
            placeholder={t("account.form_password_placeholder")}
            handleChange={handleChange}
            type="password"
            error={errors.password}
            isPopup
          />
        </FieldContainer>
        <FieldContainer>
          <Field
            data={formData}
            name="password2"
            placeholder={t("account.form_confirm_password_placeholder")}
            handleChange={handleChange}
            type="password"
            error={errors.password2}
            isPopup
          />
        </FieldContainer>
      </Fields>
      <StyledSubmitButton type="submit">
        {t("account.register_submit")}
      </StyledSubmitButton>
      <Terms>
        <Trans i18nKey={"footer.toc"}>
          By signing up, you agree to receive emails from Kimaï and accept our
          web <a href={"/terms-and-conditions"} target="_blank" rel="noreferrer">terms of service</a>.
        </Trans>
      </Terms>
    </form>
  )
}

export default withTranslation()(Register)
